import { EditMachine } from '@features/Contractor/Machine/Edit'
import { createFileRoute } from '@tanstack/react-router'
import { t } from '@utils/i18n-to-migrate'

const EditMachineRoute: React.FC = () => {
  const { contractorId, machineId } = Route.useParams()
  return <EditMachine contractorId={contractorId} machineId={machineId} />
}

export const Route = createFileRoute('/contractor/$contractorId/machines/$machineId/edit')({
  component: EditMachineRoute,
  staticData: {
    breadcrumb: t('contractor.editMachine.title'),
  },
})
